import { z } from "zod";
import { UserRole } from "../auth/auth.schema.ts";
import { CustomerId } from "../fsm/fsm.schema.ts";

export const CustomerDto = z.object({
  id: CustomerId,
  slug: z.string(),
  name: z.string(),
  isSystem: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type CustomerDto = z.infer<typeof CustomerDto>;

export const CreateCustomerInput = z.object({
  slug: z.string().regex(/^[a-z0-9-]+$/),
  name: z.string().min(1),
});

export type CreateCustomerInput = z.infer<typeof CreateCustomerInput>;

export const UpdateCustomerInput = z.object({
  slug: z
    .string()
    .regex(/^[a-z0-9-]+$/)
    .optional(),
  name: z.string().min(1).optional(),
});

export type UpdateCustomerInput = z.infer<typeof UpdateCustomerInput>;

export const AssignUserToCustomerInput = z.object({
  userId: z.string().uuid(),
  customerId: CustomerId,
  role: UserRole,
});

export type AssignUserToCustomerInput = z.infer<
  typeof AssignUserToCustomerInput
>;

export const RemoveUserFromCustomerInput = z.object({
  userId: z.string().uuid(),
  customerId: CustomerId,
});

export type RemoveUserFromCustomerInput = z.infer<
  typeof RemoveUserFromCustomerInput
>;

export const UserCustomerDto = z.object({
  userId: z.string(),
  customerId: CustomerId,
  role: UserRole,
  isActive: z.boolean().default(true),
  deactivatedAt: z.string().nullable().optional(),
  deactivatedBy: z.string().uuid().nullable().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export type UserCustomerDto = z.infer<typeof UserCustomerDto>;

export const DeactivateUserCustomerInput = z.object({
  userId: z.string().uuid(),
  customerId: CustomerId,
  deactivatedBy: z.string().uuid(),
});

export type DeactivateUserCustomerInput = z.infer<
  typeof DeactivateUserCustomerInput
>;
